export const userData = {
    name: 'Tom Cook',
    email: 'tom@example.com',
    imageUrl:
        'https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/hbzdzch5ldxw6pszwmej.png',
}


const allAccess = ['estudiante', 'profesor', 'control escolar', 'administrativo', 'desarrollador', 'director', 'subdirector', 'coordinador', 'ventas', 'cobranza', 'invitado'];

const onlyCandidate = ['administrativo', 'desarrollador', 'director', 'subdirector', 'coordinador', 'ventas'];

export const onlyCourse = ['estudiante', 'profesor', 'control escolar', 'administrativo', 'desarrollador', 'director', 'subdirector', 'cobranza', 'ventas'];

const onlyUsers = ['administrativo', 'desarrollador', 'director', 'subdirector'];

const onlyStudents = ['administrativo', 'control escolar', 'desarrollador', 'director', 'subdirector', 'cobranza', 'ventas'];

const onlyPayment = ['desarrollador', 'director', 'subdirector', 'ventas', 'cobranza'];

const onlyPaymentAndStudents = ['estudiante'];

const onlySetting = ['desarrollador', 'director', 'subdirector'];

export const onlyRequests = ['administrativo', 'control escolar', 'desarrollador', 'director', 'subdirector', 'coordinador'];

export const onlyInvoice = ['director', 'cobranza', 'ventas'];

export const onlyDirectors = ['director'];

export const navigation = [
    { name: 'Inicio', href: '/', access: allAccess },
    // { name: 'Pagos', href: '/mis-pagos', access: onlyPaymentAndStudents },
    { name: 'Candidatos', href: '/candidatos', access: onlyCandidate },
    { name: 'Cursos', href: '/cursos', access: onlyCourse },
    { name: 'Personal', href: '/usuarios', access: onlyUsers },
    { name: 'Alumnos', href: '/alumnos', access: onlyStudents },
    { name: 'Pagos', href: '/pagos', access: onlyPayment },
];

export const navigationMovil = [
    { name: 'Inicio', href: '/', access: allAccess },
    { name: 'Candidatos', href: '/candidatos', access: onlyCandidate },
    { name: 'Pagos', href: '/mis-pagos', access: onlyPaymentAndStudents },
    { name: 'Cursos', href: '/cursos', access: onlyCourse },
    { name: 'Personal', href: '/usuarios', access: onlyUsers },
    { name: 'Alumnos', href: '/alumnos', access: onlyStudents },
    { name: 'Pagos', href: '/pagos', access: onlyPayment },
    { name: 'Cambios de alumnos', href: '/control-estudiantes', access: onlyRequests },
    { name: 'Facturas', href: '/control-facturas', access: onlyInvoice },
];

export const userNavigation = [
    { name: 'Perfil', href: '/mi-perfil', access: allAccess },
    { name: 'Configuracion', href: '/ajustes', access: onlySetting },
];

export const userMenu = [
    { name: 'Perfil', description: 'Edita y actuliza tu perfil de usuario.', href: 'mi-perfil', icon: "UserIcon", access: allAccess },
    { name: 'Subir comprobante de pago', description: 'Subir tu comprobante de pago para validar tu pago.', href: 'mis-pagos', icon: "DocumentCurrencyDollarIcon", access: onlyPaymentAndStudents, openPaymentDrawer: true },
    { name: 'Cursos', description: 'Ver y gestionar tus cursos.', href: 'cursos', icon: "BookOpenIcon", access: onlyCourse },
    { name: 'Candidatos', description: 'Ver y validar a los nuevos candidatos', href: 'candidatos', icon: "UsersIcon", access: onlyCandidate },
    { name: 'Personal', description: 'Ver y gestionar al personal operativo', href: 'usuarios', icon: "UserGroupIcon", access: onlyUsers },
    { name: 'Estudiantes', description: 'Ver y gestionar a los estudiantes de la plataforma', href: 'alumnos', icon: "AcademicCapIcon", access: onlyStudents },
    { name: 'Pagos', description: 'Ver y validar pagos de suscripcion', href: 'pagos', icon: "CreditCardIcon", access: onlyPayment },
    { name: 'Cambios de alumnos', description: 'Validar y solicitar cambios de estudiantes', href: 'control-estudiantes', icon: "ArrowPathRoundedSquareIcon", access: onlyRequests },
    { name: 'Facturas', description: 'Historial de facturas solicitas', href: 'control-facturas', icon: "DocumentCurrencyDollarIcon", access: onlyInvoice },
    { name: 'Usuarios Online', description: 'Monitorear conexiones y sesiones activas de la plataforma.', href: 'usuarios-online', icon: "SignalIcon", access: onlyDirectors },
    { name: 'Configuracion', description: 'Personalizar la configuración de la aplicación', href: 'ajustes', icon: "Cog8ToothIcon", access: onlySetting },
    // { name: 'Notificaciones', description: "Administrar las notificaciones de la aplicación", href: 'notificaciones', icon: "BellIcon", access: onlyCourse },
    // { name: 'Tareas', description: 'Acceder y completar las tareas asignadas', href: 'tareas', icon: "RectangleStackIcon" },
];

export const locationState = [
    { value: "aguascalientes", description: "Aguascalientes" },
    { value: "baja california", description: "Baja California" },
    { value: "baja california sur", description: "Baja California Sur" },
    { value: "campeche", description: "Campeche" },
    { value: "coahuila", description: "Coahuila" },
    { value: "colima", description: "Colima" },
    { value: "chiapas", description: "Chiapas" },
    { value: "chihuahua", description: "Chihuahua" },
    { value: "ciudad de méxico", description: "Ciudad de México" },
    { value: "durango", description: "Durango" },
    { value: "guanajuato", description: "Guanajuato" },
    { value: "guerrero", description: "Guerrero" },
    { value: "hidalgo", description: "Hidalgo" },
    { value: "jalisco", description: "Jalisco" },
    { value: "estado de méxico", description: "Estado de México" },
    { value: "michoacán", description: "Michoacán" },
    { value: "morelos", description: "Morelos" },
    { value: "nayarit", description: "Nayarit" },
    { value: "nuevo león", description: "Nuevo León" },
    { value: "oaxaca", description: "Oaxaca" },
    { value: "puebla", description: "Puebla" },
    { value: "querétaro", description: "Querétaro" },
    { value: "quintana roo", description: "Quintana Roo" },
    { value: "san luis potosí", description: "San Luis Potosí" },
    { value: "sinaloa", description: "Sinaloa" },
    { value: "sonora", description: "Sonora" },
    { value: "tabasco", description: "Tabasco" },
    { value: "tamaulipas", description: "Tamaulipas" },
    { value: "tlaxcala", description: "Tlaxcala" },
    { value: "veracruz", description: "Veracruz" },
    { value: "yucatán", description: "Yucatán" },
    { value: "zacatecas", description: "Zacatecas" }
];

export const levelEducation = [
    { value: "primaria", description: "Primaria" },
    { value: "secundaria", description: "Secundaria" },
    { value: "bachillerato o preparatoria", description: "Bachillerato o preparatoria" },
    { value: "educación técnica o profesional", description: "Educación técnica" },
    { value: "licenciatura", description: "Licenciatura" },
    { value: "maestría", description: "Maestría" },
    { value: "doctorado", description: "Doctorado" },
];

export const languages = [
    { value: "ingles", description: "ingles" },
    { value: "frances", description: "frances" },
    { value: "japones", description: "japones" },
];

export const accounts = [
    { value: "9801 9878 0978 0919", description: "9801 9878 0978 0919" },
    { value: "9878 9889 0019 0918", description: "9878 9889 0019 0918" },
    { value: "9232 2200 1100 0010", description: "9232 2200 1100 0010" },
    { value: "9078 9890 0912 1230", description: "9078 9890 0912 1230" },
];

export const typeUserOptions = [
    { value: "director", description: "director" },
    { value: "subdirector", description: "subdirector" },
    { value: "administrativo", description: "administrativo" },
    { value: "desarrollador", description: "desarrollador" },
    { value: "control escolar", description: "control escolar" },
    { value: "coordinador", description: "coordinador" },
    { value: "cobranza", description: "cobranza" },
    { value: "ventas", description: "ventas" },
    { value: "profesor", description: "profesor" },
    { value: "estudiante", description: "estudiante" },
];

export const nivels = [
    { value: "nivel 1", description: "nivel 1" },
    { value: "nivel 2", description: "nivel 2" },
    { value: "nivel 3", description: "nivel 3" },
    { value: "nivel 4", description: "nivel 4" },
];

export const colors = [
    { name: 'red', clase: 'bg-red-600', selectedClass: 'ring-red-600 shadow-red-500' },
    { name: 'orange', clase: 'bg-orange-500', selectedClass: 'ring-orange-500 shadow-orange-500' },
    { name: 'yellow', clase: 'bg-yellow-400', selectedClass: 'ring-yellow-400 shadow-yellow-500' },
    { name: 'green', clase: 'bg-lime-600', selectedClass: 'ring-lime-600 shadow-lime-500' },
    { name: 'blue', clase: 'bg-sky-500', selectedClass: 'ring-sky-500 shadow-sky-500' },
    { name: 'purple', clase: 'bg-purple-500', selectedClass: 'ring-purple-500 shadow-purple-500' },
];


export const avatars = [
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/mgdi1glpnoyebozm2ifj.png" },
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/hbzdzch5ldxw6pszwmej.png" },
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/hc0kpsmuj6iklivapeo9.png" },
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/dxx2uay4ajrs6rt9w96x.png" },
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/leyq6ryeeqavaewponfm.png" },
    { urlAvatar: "https://res.cloudinary.com/dax0v05jz/image/upload/v1708645791/uploads/xwqiz0lxnd0rvmhda68g.png" }
];

export const paymentStatus = [
    {
        "id": "allStatus",
        "description": "Todos los estados",
        "name": "Todos los pagos",
    },
    {
        "id": "validado",
        "description": "validado",
        "name": "Validado",
    },
    {
        "id": "pendiente",
        "description": "pendiente",
        "name": "Pendiente",
    },
    {
        "id": "rechazado",
        "description": "rechazado",
        "name": "Rechazado",
    },
];

export const paymentTypes = [
    {
        "id": "allTypes",
        "description": "Todos los tipos",
        "name": "Todos los pagos",
    },
    {
        "id": "suscripcion",
        "description": "suscripcion",
        "name": "Suscripcion",
    },
    {
        "id": "pre registro",
        "description": "pre registro",
        "name": "Pre registro",
    },
];

export const statusCourse = [
    {
        "value": "en curso",
        "name": "en curso",
        "description": "en curso"
    },
    {
        "value": "abierto",
        "name": "abierto",
        "description": "abierto"
    },
    {
        "value": "finalizado",
        "name": "finalizado",
        "description": "finalizado"
    },
    {
        "value": "completado",
        "name": "completado",
        "description": "completado"
    },
    {
        "value": "cancelado",
        "name": "cancelado",
        "description": "cancelado"
    },
];

export const listDays = [
    { value: "lunes", description: "lunes" },
    { value: "martes", description: "martes" },
    { value: "miércoles", description: "miércoles" },
    { value: "jueves", description: "jueves" },
    { value: "viernes", description: "viernes" },
    { value: "sábado", description: "sábado" },
];

export const statusStudents = [
    {
        "value": "activo",
        "name": "activo",
        "description": "activo"
    },
    {
        "value": "inactivo",
        "name": "inactivo",
        "description": "inactivo"
    },
    {
        "value": "suspendido",
        "name": "suspendido",
        "description": "suspendido"
    },
    {
        "value": "baja",
        "name": "baja",
        "description": "baja"
    }
];

export const optionsTypeUser = [
    {
        "value": "estudiante",
        "label": "estudiante"
    },
    {
        "value": "profesor",
        "label": "profesor"
    },
    {
        "value": "control escolar",
        "label": "control escolar"
    },
    {
        "value": "administrativo",
        "label": "administrativo"
    },
    {
        "value": "desarrollador",
        "label": "desarrollador"
    },
    {
        "value": "director",
        "label": "director"
    },
    {
        "value": "subdirector",
        "label": "subdirector"
    },
    {
        "value": "coordinador",
        "label": "coordinador"
    },
    {
        "value": "ventas",
        "label": "ventas"
    },
    {
        "value": "cobranza",
        "label": "cobranza"
    },
    {
        "value": "invitado",
        "label": "invitado"
    }
];


export const categories = [
    {
        "value": "control escolar",
        "label": "Control escolar"
    },
    {
        "value": "pagos",
        "label": "Pagos"
    },
    {
        "value": "coordinador",
        "label": "Coordinador"
    },
    {
        "value": "ventas",
        "label": "Ventas"
    },
    {
        "value": "cobranza",
        "label": "Cobranza"
    },
];


export const optionsSort = [
    {
        value: 'desc',
        label: 'Más reciente',
        description: 'Primero los registros más nuevos',
        iconName: 'arrowDown',
    },
    {
        value: 'asc',
        label: 'Más antiguo',
        description: 'Primero los registros más viejos',
        iconName: 'arrowUp',
    },
]

export const optionsStatusPayment = [
    {
        value: 'validado',
        label: 'Validado',
        description: 'Pagos aprobados y confirmados',
        dotClass: 'bg-emerald-500',
    },
    {
        value: 'pendiente',
        label: 'Pendiente',
        description: 'Pagos en espera de validación',
        dotClass: 'bg-amber-500',
    },
    {
        value: 'rechazado',
        label: 'Rechazado',
        description: 'Pagos no aprobados',
        dotClass: 'bg-rose-500',
    },
]

export const optionsStatusRequest = [
    {
        "value": "",
        "label": "Todas las solicitudes"
    },
    {
        "value": "done",
        "label": "Completado"
    },
    {
        "value": "pending",
        "label": "Pendiente"
    }
]

export const optionsStatusRequestStudents = [
    {
        "value": "",
        "label": "Todas las solicitudes"
    },
    {
        "value": "done",
        "label": "Completado"
    },
    {
        "value": "pending",
        "label": "Pendiente"
    }
]

/** Filtro de estatus para control de facturas (`requestStatus` en API). Incluye `dotClass` para el popover de checkboxes. */
export const optionsStatusRequestInvoiceFilter = [
	{
		value: 'pending',
		label: 'Pendiente',
		description: 'Solicitudes en espera de confirmación',
		dotClass: 'bg-orange-500',
	},
	{
		value: 'done',
		label: 'Completado',
		description: 'Solicitudes confirmadas',
		dotClass: 'bg-emerald-500',
	},
	{
		value: 'declined',
		label: 'Rechazada',
		description: 'Solicitudes no aprobadas',
		dotClass: 'bg-rose-500',
	},
]

export const optionsStatusCandidate = [
    {
        value: 'completado',
        label: 'Completado',
        description: 'Candidatos con proceso finalizado',
        dotClass: 'bg-emerald-500',
    },
    {
        value: 'validando',
        label: 'Validando',
        description: 'En proceso de validación',
        dotClass: 'bg-rose-500',
    },
    {
        value: 'prospecto',
        label: 'Prospecto',
        description: 'Candidatos interesados',
        dotClass: 'bg-orange-500',
    },
]

export const statusStudentsFilter = [
    {
        value: 'activo',
        label: 'Activo',
        description: 'Estudiantes con acceso vigente',
        dotClass: 'bg-emerald-500',
    },
    {
        value: 'inactivo',
        label: 'Inactivo',
        description: 'Estudiantes sin actividad reciente',
        dotClass: 'bg-gray-400',
    },
    {
        value: 'suspendido',
        label: 'Suspendido',
        description: 'Acceso suspendido temporalmente',
        dotClass: 'bg-amber-500',
    },
    {
        value: 'baja',
        label: 'Baja',
        description: 'Estudiantes dados de baja',
        dotClass: 'bg-rose-500',
    },
]

export const statusSubscriptionFilter = [
    {
        value: 'pagado',
        label: 'Pagado',
        description: 'Suscripciones al corriente',
        dotClass: 'bg-emerald-500',
    },
    {
        value: 'vencida',
        label: 'Vencida',
        description: 'Suscripciones con pago pendiente',
        dotClass: 'bg-rose-500',
    },
]

export const statusCourses = [
    {
        "value": "en curso",
        "description": "en curso"
    },
    {
        "value": "abierto",
        "description": "abierto"
    },
    {
        "value": "finalizado",
        "description": "finalizado"
    },
    {
        "value": "completado",
        "description": "completado"
    },
    {
        "value": "cancelado",
        "description": "cancelado"
    }
];

// Opciones para los filtros
export const sortOptions = [
    {
        value: 'desc',
        label: 'Más reciente',
        description: 'Primero las actividades más nuevas',
        iconName: 'arrowDown',
    },
    {
        value: 'asc',
        label: 'Más antiguo',
        description: 'Primero las actividades más viejas',
        iconName: 'arrowUp',
    },
];

/** Opciones para los filtros de categorías */
export const categoryOptions = [
    {
        value: 'user',
        label: 'Usuario',
        description: 'Cambios al perfil y cursos',
        dotClass: 'bg-blue-500',
    },
    {
        value: 'payment',
        label: 'Pagos',
        description: 'Movimientos de pagos',
        dotClass: 'bg-emerald-500',
    },
    {
        value: 'request',
        label: 'Solicitudes',
        description: 'Solicitudes y facturas',
        dotClass: 'bg-amber-500',
    },
    {
        value: 'logs',
        label: 'Logs',
        description: 'Errores e inicios de sesión',
        dotClass: 'bg-rose-500',
    },
    {
        value: 'nota',
        label: 'Notas',
        description: 'Notas internas del estudiante',
        dotClass: 'bg-violet-500',
    },
];

/** Opciones para los filtros de notas */
export const NOTE_STATUS_OPTIONS = [
    {
        value: 'abierta',
        label: 'Abierta',
        description: 'Notas nuevas sin atender',
        dotClass: 'bg-amber-500',
    },
    {
        value: 'en seguimiento',
        label: 'En seguimiento',
        description: 'Notas con actividad en curso',
        dotClass: 'bg-sky-500',
    },
    {
        value: 'cerrada',
        label: 'Cerrada',
        description: 'Notas resueltas o archivadas',
        dotClass: 'bg-gray-400',
    },
];